import React, { Component } from 'react'
import Modal from 'react-modal'
import { connect } from 'react-redux';

import {
    addDocumento, addAgrupador, getAgrupador
} from '../../actions'

class ModalFormAgrupador extends Component {
    constructor(props){
        super(props)

        this.state = {
            modalIsOpen: true,
            file: undefined
        }

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.onSubmitForm = this.onSubmitForm.bind(this);
    }

    openModal() {
        //this.setState({modalIsOpen: true});
        this.props.openModal()
    }

    closeModal() {
        //console.log(this.props)
        this.props.closeModal()
        //this.setState({modalIsOpen: false});
    }

    handleInputChange(event){
        this.setState({
            [event.target.name]: event.target.value 
        })
    }

    onSubmitForm(event){
        event.preventDefault()
        const { titulo, descricao } = this.state
        this.props.addAgrupador(titulo, descricao, res => {
            if(res) {
                this.setState({ titulo: '', descricao: ''})
                this.props.getAgrupador()
            }
        })
    }
    
    render(){
        const { load_agrupador, error_doc, agrupador_success } = this.props.documentos
        return(
            <div className="modal fade" id="modalFormAgrupador" tabIndex="-1" role="dialog" aria-labelledby="modalAddGroup"
            aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <form onSubmit ={this.onSubmitForm}>
                            <div className="modal-header">
                                <h5 className="modal-title" id="modalAddGroup">Adicionar Agrupador</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.closeModal}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">

                                <div className="form-group">
                                    <label  className="sr-only">Título</label>
                                    <input name="titulo" type="text" value={this.state.titulo} className="form-control" placeholder="Titulo" required onChange={this.handleInputChange} />
                                </div>

                                <div className="form-group">
                                    <label  className="sr-only">Descrição</label>
                                    <input name="descricao" type="text" value={this.state.descricao} className="form-control" placeholder="Descrição" required onChange={this.handleInputChange} />
                                </div>
                            </div>
                            
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={this.closeModal}>Cancelar</button>
                                <button type="submit" className="btn btn-primary"  disabled={load_agrupador}>
                                    {load_agrupador ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>:null}
                                {load_agrupador ? 'Aguarde...' : 'Adicionar'} 
                                </button>
                            </div>
                        </form>

                        {error_doc != ''
                            ?<div className="alert alert-danger" role="alert" style={{marginTop:'1%'}}>
                                {error_doc}
                            </div>
                            :null
                        }

                        {agrupador_success != '' && agrupador_success != undefined
                            ?<div className="alert alert-success" role="alert" style={{marginTop:'1%'}}>
                                {agrupador_success}
                            </div>
                            :null
                        }
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = ({ documentos }) => {
    return {
        documentos
    }
}

export default connect(mapStateToProps, {
    addDocumento, addAgrupador, getAgrupador
})(ModalFormAgrupador);

const customStyles = {
    main: {
        paddingLeft: '2%',
        paddingRight: '2%'
    },
    modal:{
        width:'50%',
        // height: '50%',
        left:'35%',
        top: '80px',
    }
}